module.exports = __webpack_public_path__ + "media/images/help/team-create-edit-edef43a677d26a2245572c57cbe053a0.png";